import Service from "@/services/triplist";
//import {router} from '@/plugins/router'

export default {
  namespaced: false,
  state: {
    customList: {},
    list: {},
    current: {},
  },
  actions: {
    getTripList({ dispatch, commit }, active) {
      Service.get(active)
        .then((data) => {
          commit("tripList", { active: active, list: data.data });
        })
        .catch((err) => {
          //dispatch("alert/error", err, { root: true });
        });
    },
    getTrip({ dispatch, commit }, id) {
      Service.getOne(id)
        .then((data) => {
          commit("currentTrip", data.data);
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
    postTripList({ dispatch, commit }, payload) {
      Service.postTripList(payload.param)
        .then((data) => {
          commit("customTripList", { name: payload.name, list: data.data });
        })
        .catch((err) => {
          dispatch("alert/error", err, { root: true });
        });
    },
  },
  mutations: {
    tripList(state, values) {
      if (values.active === 1) {
        state.list["active"] = values.list;
      } else if (values.active === 2) {
        state.list["toRegister"] = values.list;
      } else {
        state.list["inactive"] = values.list;
      }
      state.list = JSON.parse(JSON.stringify(state.list));
    },
    currentTrip(state, values) {
      state.current = values;
    },
    customTripList(state, payload) {
      state.customList[payload.name] = payload.list;
    },
  },
};
